import { render, staticRenderFns } from "./component-pagination.vue?vue&type=template&id=60ce7fe7&scoped=true&"
import script from "./component-pagination.vue?vue&type=script&lang=js&"
export * from "./component-pagination.vue?vue&type=script&lang=js&"
import style0 from "./component-pagination.vue?vue&type=style&index=0&id=60ce7fe7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce7fe7",
  null
  
)

export default component.exports